<template lang="pug">
  v-dialog(v-if="addNewTimeBlockDialog" v-model="addNewTimeBlockDialog" max-width="700" :fullscreen="$vuetify.breakpoint.smAndDown" persistent )
    WarningDeleteTimeBlockDialog(v-if="showWarningDialog" :showWarningDialog="showWarningDialog" :selectedTimeBlock="selectedTimeBlock" @yes="onDeleteButtonClick" @close="closeWarningDialog")
    v-snackbar(v-model="showSnackBar" :color="snackBarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    v-card.d-flex.flex-column()
      v-card-title.headline {{ $t('businessPage.timeBlockLabel') }}
      v-card-text.pb-1.flex-shrink-0.flex-grow-1.card-body
        v-form(v-model="formIsValid" ref="form" lazy-validation @submit.prevent="saveTimeBlock" :disabled="saveInProgress")
          v-row
            v-col(cols="12")
              v-text-field(v-model="timeBlockName" :rules="timeBlockNameRules" autofocus
              :label="$t('businessPage.timeBlockLabel')" outlined)
          v-row
            v-col.pb-0(cols="12" xl="7" md="7" sm="12")
              v-menu(
                v-if="this.$vuetify.breakpoint.mdAndUp"
                ref="menu"
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="time"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                )
                template( v-slot:activator="{ on, attrs }")
                  v-text-field(
                  outlined
                  :value="getformattedTime"
                  :label="$t('businessPage.timeBlockTimeLimitLabel')"
                  prepend-icon="fas fa-clock"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  clear-icon="fas fa-times"
                  @click:clear
                  clearable
                  )
                v-time-picker(
                  v-if="menu2"
                  v-model="time"
                  full-width
                  format="24hr"
                  )
                  v-spacer
                  v-btn(@click="menu2 = false" text) {{ $t('buttons.closeButtonLabel') }}
                  v-btn(:disabled="!time" color="primary" @click="$refs.menu.save(time)") {{ $t('buttons.okButtonLabel') }}
              v-dialog(v-else
                fullscreen
                ref="dialog"
                v-model="menu2"
                :return-value.sync="time"
                persistent
                )
                template( v-slot:activator="{ on, attrs }")
                  v-text-field(
                    outlined
                    :value="getformattedTime"
                    :label="$t('businessPage.timeBlockTimeLimitLabel')"
                    prepend-icon="fas fa-clock"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clear-icon="fas fa-times"
                    @click:clear
                    clearable
                    )
                v-time-picker(
                  v-if="menu2"
                  v-model="time"
                  full-width
                  format="24hr"
                  )
                  v-spacer
                  v-btn(@click="menu2 = false" text) {{ $t('buttons.closeButtonLabel') }}
                  v-btn(:disabled="!time" color="primary" @click="$refs.dialog.save(time)") {{ $t('buttons.okButtonLabel') }}
            v-col.pb-7(cols="12" xl="5" md="5" sm="12")
              v-checkbox(:label="$t('businessPage.timeBlockOrderLabel')"
                v-model="isPreviousDay"
                on-icon="fas fa-check-square"
                off-icon="far fa-square")
      v-divider
      v-card-actions.justify-end
        v-btn(v-if="this.selectedTimeBlock" @click="deleteButtonClick" color="error" :disabled="saveInProgress") {{ $t('businessPage.deleteButtonLabel') }}
        v-spacer
        v-btn(@click="onCloseButtonClick" text :disabled="saveInProgress") {{ $t('buttons.closeButtonLabel') }}
        v-btn( color="primary" @click="saveTimeBlock" :loading="saveInProgress" :disabled="saveInProgress || !formIsValid") {{ $t('buttons.saveButtonLabel') }}

</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import i18n from "@/i18n";
import BusinessTimeBlockCollection from "@/model/business/BusinessTimeBlockCollection";
import {Action} from "vuex-class";
import {DELETE_NEW_TIME_BLOCK, SAVE_NEW_TIME_BLOCK, UPDATE_TIME_BLOCK} from "@/store/action-types";
import {NewTimeBlockPayload, UpdateTimeBlockPayload} from "@/types/payload";
import WarningDeleteTimeBlockDialog from "@/components/business/WarningDeleteTimeBlockDialog.vue";
import moment from "moment";
import BusinessModel from "@/model/menu/BusinessModel";

@Component({
  components: {
    WarningDeleteTimeBlockDialog
  }
})
export default class TimeBlockDialog extends Vue {
  $refs!: {
    form: Vue & {
      validate(): boolean,
      resetValidation(): boolean
    }
  }

  @Prop({type: Boolean, default: false}) addNewTimeBlockDialog!: boolean
  @Prop({type: Array as () => BusinessTimeBlockCollection[]}) selectedTimeBlockColection!: BusinessTimeBlockCollection[]
  @Prop({type: Object as () => BusinessTimeBlockCollection}) selectedTimeBlock!: BusinessTimeBlockCollection
  @Prop({type: Object as () => BusinessModel}) businessToEdit!: BusinessModel
  @Action(SAVE_NEW_TIME_BLOCK) saveNewTimeBlock!: { (payload: NewTimeBlockPayload): Promise<any> }
  @Action(DELETE_NEW_TIME_BLOCK) deleteSelectedTimeBlock!: { (payload: string): Promise<void> }
  @Action(UPDATE_TIME_BLOCK) updateSelectedTimeBlock!: { (updatePayload: UpdateTimeBlockPayload): Promise<any> }

  private timeBlockName: string = ""
  private saveInProgress: boolean = false
  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''
  private formIsValid: boolean = false
  private timeBlockNameRules: Array<(v: string) => string | boolean> = [
    (v: string) => !!v || i18n.t('businessPage.TimeNameValidationLabel').toString()
  ]
  private timeBlockTimeRules: Array<(v: string) => string | boolean> = [
    (v: string) => !!v || i18n.t('businessPage.timeValidationText').toString()
  ]
  private showWarningDialog: boolean = false
  private menu2: boolean = false
  private time: string = ''
  private isPreviousDay: boolean = false

   get getformattedTime (): string {
    return this.time ? moment(this.time, 'HH:mm:ss').format('HH:mm') : ''
  }

  onCloseButtonClick(): void {
    this.$emit('close')
  }

  deleteButtonClick () {
    this.showWarningDialog = true
  }

  closeWarningDialog () {
    this.showWarningDialog = false
  }

  async onDeleteButtonClick ():Promise<void> {
    const payload: string = this.selectedTimeBlock!.id
    try {
      await this.deleteSelectedTimeBlock(payload)
      this.$emit('deleted')
      this.onCloseButtonClick()

    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('errors.deleteDataError').toString()
    } finally {
    }
  }

  async saveTimeBlock(): Promise<void> {
      if(!this.selectedTimeBlock){
        let payload: NewTimeBlockPayload = {
          title: this.timeBlockName,
          business: this.businessToEdit.id,
          order: this.selectedTimeBlockColection.length + 1,
          reservationDeadline: this.time ? this.time + ':00': null,
          deadlineForPreviousDay: this.isPreviousDay
        }

        try {
          this.saveInProgress = true
          await this.saveNewTimeBlock(payload)
          this.onCloseButtonClick()
          this.$emit('saved')
        }catch (e) {
          this.showSnackBar = true
          this.snackBarColor = 'error'
          this.snackBarMessage = this.$t('errors.saveErrorMessage').toString()
        }finally {
          this.saveInProgress = false

        }
      }else{
        let payload: UpdateTimeBlockPayload = {
          id:this.selectedTimeBlock.id,
          title: this.timeBlockName,
          business: this.businessToEdit.id,
          order: this.selectedTimeBlock.order,
          reservationDeadline: this.time ? moment(this.time,'HH:mm' ).format('HH:mm:ss') : null,
          deadlineForPreviousDay: this.isPreviousDay
        }
        try {
          this.saveInProgress = true
          await this.updateSelectedTimeBlock(payload)
          this.$emit('updated')
          this.onCloseButtonClick()
        } catch (e) {
          this.showSnackBar = true
          this.snackBarColor = 'error'
          this.snackBarMessage = this.$t('errors.saveErrorMessage').toString()
        } finally {
          this.saveInProgress = false
        }
      }
  }

  mounted(): void {
    if(this.selectedTimeBlock){
      this.timeBlockName = this.selectedTimeBlock.title
      this.time = this.selectedTimeBlock.reservationDeadline
      this.isPreviousDay = this.selectedTimeBlock.deadlineForPreviousDay
    } else {
      this.timeBlockName = ''
      this.time = ''
      this.isPreviousDay = false
    }
  }
}
</script>

<style lang="stylus" scoped>

.custom-time-picker .v-time-picker-clock {
  clock none
}

</style>
